import { render, staticRenderFns } from "./SendVideo.vue?vue&type=template&id=79f73f9b&scoped=true&"
import script from "./SendVideo.vue?vue&type=script&lang=js&"
export * from "./SendVideo.vue?vue&type=script&lang=js&"
import style0 from "./SendVideo.vue?vue&type=style&index=0&id=79f73f9b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f73f9b",
  null
  
)

export default component.exports